import {textDecoration} from '@chakra-ui/react'
import {pxToRem} from '../../../../utills/pxToRem'

export const infoCardLinkStyle = {
    color: 'cav_red',
    alignSelf: 'end',
    fontSize: 'xs',
    fontStyle: 'normal',
    fontWeight: 'medium',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    textTransform: 'uppercase',
    textDecoration: 'underline',
    mt: {base: pxToRem(8), md: `${pxToRem(23)} !important`}
}

export const infoCardDescriptionStyle = {
    color: 'black',
    fontSize: pxToRem(13),
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: '1px',
    mb: '0'
}

export const infoCardTitleStyle = {
    color: 'black',
    fontSize: 'lg',
    mx: '0 !important',
    fontStyle: 'normal',
    fontWeight: 'medium',
    lineHeight: 'normal',
    letterSpacing: pxToRem(3),
    textTransform: 'uppercase'
}

export const carouselFullStyle = {
    mt: '0 !important',
    padding: {base: '0 11px', lg: '0'},
    '> div': {
        '> div': {
            '> div:last-child': {
                padding: {base: '0 11px', lg: '0 45px 0 0'}
            }
        }
    }
}
